export function openInNewTab(ev, link) {
  window.open(link, '_blank');
  window.focus();
  ev.stopPropagation();
}

export const isExternalContext = (context) => context === 'external';
